/**
 * Created by Karol Kluska on 29.11.17.
 */

angular
  .module('app')
  .factory('Categories', Categories);

function Categories() {
  var categoriesList = [];

  function getCategories() {
    return categoriesList;
  }

  function setCategories(categories) {
    if (angular.isArray(categories)) {
      categoriesList = categories;
    }
  }

  return {
    setCategories: setCategories,
    getCategories: getCategories
  };
}
